import React from "react";
import NextImage from "next/image";
import Rating from "react-rating";

import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import Breadcrumb from "@/components/Atoms/Breadcrumb";

import theme from "@/foundation/Theme";

import {
  HeroBox,
  LHSBox,
  Badge,
  RecipeTitle,
  Subtitle,
  RHSBox,
  RatingBox,
  RatingText,
  BottomBox,
  AboutRating,
  RatingCount,
  Strong,
  StarCountBox,
  DetailBox,
  Tags,
  TimeIcon,
  BannerText,
} from "./style";

const EmptyStar = () => (
  <StyledSvgSprite
    icon="icon-star-empty"
    stroke={theme.colorsV2.warning.shade_400}
    height="24px"
    width="24px"
  />
);

const FullStar = () => (
  <StyledSvgSprite
    icon="icon-star-fill"
    fill={theme.colorsV2.warning.shade_400}
    stroke={theme.colorsV2.warning.shade_400}
    height="24px"
    width="24px"
  />
);

export const GetHeroContent = ({ data }: any) => {
  const { rating, ratingText, aboutRating, duration, ingredientsCount } = data;
  return (
    <>
      <BottomBox>
        <RatingBox>
          <RatingText variant="label2">{ratingText}</RatingText>
          <StarCountBox>
            <Rating
              initialRating={rating}
              readonly
              emptySymbol={<EmptyStar />}
              fullSymbol={<FullStar />}
            />
            <RatingCount
              variant="label3"
              fontFamily={"var(--man-400)"}
              fontSize="16px"
            >
              <Strong>{rating}</Strong>/5
            </RatingCount>
          </StarCountBox>
        </RatingBox>
        {aboutRating && (
          <AboutRating variant="label3">{aboutRating}</AboutRating>
        )}
      </BottomBox>
      <DetailBox>
        {duration && (
          <Tags variant="label2">
            <TimeIcon icon="icon-clock-3" height="16px" width="16px" />
            {duration}
          </Tags>
        )}
        {ingredientsCount && <Tags variant="label2">{ingredientsCount}</Tags>}
      </DetailBox>
    </>
  );
};

function HeroBottom({ data = {}, width }) {
  const { subtitle, recipeTitle, image, badgeTitle } = data || {};

  const items = [
    {
      title: "Home",
      link: "/",
    },
    {
      title: "Recipes",
      link: "/recipes",
    },
    {
      title: recipeTitle,
    },
  ];

  return (
    <>
      <h1 style={{ display: "none" }}>{recipeTitle}</h1>

      <HeroBox backImage={image}>
        <LHSBox>
          <Breadcrumb items={items} />
          {badgeTitle && <Badge variant="label3">{badgeTitle}</Badge>}
          <BannerText>
            {recipeTitle && (
              <RecipeTitle variant="display2">
                {recipeTitle.toLowerCase()}
              </RecipeTitle>
            )}
            {subtitle && <Subtitle variant="label2">{subtitle}</Subtitle>}
          </BannerText>
          {width > 992 && <GetHeroContent data={data} />}
        </LHSBox>
        {width > 992 && image && (
          <RHSBox>
            <NextImage
              src={image}
              fill={true}
              style={{ objectFit: "cover" }}
              alt={recipeTitle}
            />
          </RHSBox>
        )}
      </HeroBox>
    </>
  );
}

export default HeroBottom;
